import classNames from 'classnames';
import { PublicationContent, PublicationContentProps, PublicationHeader, PublicationHeaderProps } from 'components/2-molecules/Publication';
import { Container, ContainerWidth } from 'components/4-habitats/Container';
import { TopArea, TopAreaProps } from 'components/4-habitats/TopArea';
import styles from './PublicationPage.module.scss';
export type PublicationPageProps = PublicationHeaderProps &
	PublicationContentProps & {
		aside?: React.ReactNode;
		additionalTop?: TopAreaProps['additional'];
		additionalPageContent?: React.ReactNode;
		topBanner?: React.ReactNode;
		children?: React.ReactNode;
		pageWidth?: ContainerWidth;
	};

export const PublicationPage: React.FC<PublicationPageProps> = ({
	aside,
	additionalTop,
	additionalPageContent,
	date,
	downloadText,
	pdf,
	heading,
	text,
	image,
	teaser,
	topBanner,
	pageWidth = 'Medium',
	children,
}) => {
	return (
		<div className={styles.PublicationPage}>
			<TopArea additional={additionalTop} topBanner={topBanner} />
			<Container width={pageWidth} className={classNames(styles.PublicationPage_container, aside && 'u-aside')} padded>
				<article>
					{additionalPageContent}
					<div className={styles.PublicationPage_content}>
						<header>
							<PublicationHeader date={date} heading={heading} />
						</header>

						<PublicationContent image={image} teaser={teaser} text={text} downloadText={downloadText} pdf={pdf} />
						{children}
					</div>
				</article>
				{aside}
			</Container>
		</div>
	);
};
